import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default function generarDeclaracionPDF(datosPersonales, calendarioActivo, formato) {
  var doc = new jsPDF("p", "mm", "a4");

  // Datos del calendario
  var cal = calendarioActivo || {};
  var documentoCal = (cal.documento || "").trim().toUpperCase();
  var nombredato = (cal.nombre || "").normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^ -]/g, '');

  // Titulo fijo segun tipo de declaracion
  var anioPresente = new Date().getFullYear();
  var clave = (documentoCal + ' ' + nombredato).toUpperCase();
  var tituloDeclaracion = '';
  if (clave.indexOf('JULIO') >= 0 || clave.indexOf('PATRIAS') >= 0 || clave.indexOf('JUL') >= 0) {
    tituloDeclaracion = 'AGUINALDO POR FIESTAS PATRIAS JULIO ' + anioPresente;
  } else if (clave.indexOf('DICIEMBRE') >= 0 || clave.indexOf('NAVIDAD') >= 0 || clave.indexOf('NAV') >= 0 || clave.indexOf('DIC') >= 0) {
    tituloDeclaracion = 'AGUINALDO POR NAVIDAD DICIEMBRE ' + anioPresente;
  } else if (clave.indexOf('ESCOLARIDAD') >= 0 || clave.indexOf('ESCOL') >= 0) {
    tituloDeclaracion = 'BONIFICACION POR ESCOLARIDAD ' + anioPresente;
  } else {
    tituloDeclaracion = nombredato;
  }

  // Textos estaticos del pie de pagina
  var pieTextos = obtenerPieTextos(clave, tituloDeclaracion);

  console.log('DEBUG PDF - documento:', documentoCal, 'tituloDeclaracion:', tituloDeclaracion, 'pieTextos:', pieTextos);

  // Extraer datos del trabajador (descripcion=etiqueta, nombre=valor)
  var datosDni = datosPersonales.filter(fila => fila.descripcion === "Dni");
  var dni = datosDni.length > 0 ? datosDni[0].nombre : '';

  var datosApPaterno = datosPersonales.filter(fila => fila.descripcion === "Ap. Paterno");
  var apellidopaterno = datosApPaterno.length > 0 ? datosApPaterno[0].nombre : '';

  var datosApMaterno = datosPersonales.filter(fila => fila.descripcion === "Ap. Materno");
  var apellidomaterno = datosApMaterno.length > 0 ? datosApMaterno[0].nombre : '';

  var datosNombres = datosPersonales.filter(fila => fila.descripcion === "Nombres");
  var nombres = datosNombres.length > 0 ? datosNombres[0].nombre : '';

  // Tipo planilla (DOA/DOC)
  var datosUno = datosPersonales.filter(fila => fila.width === "uno");
  var modalidadcontrata = datosUno.length > 0 ? datosUno[0].datos : '';
  var tipoPlanilla = modalidadcontrata.substring(0, 3);

  // Departamento
  var datosCuatro = datosPersonales.filter(fila => fila.width === "cuatro");
  var departamento = datosCuatro.length > 0 ? datosCuatro[0].datos : '';

  // Escuela
  var datosCinco = datosPersonales.filter(fila => fila.width === "cinco");
  var escuela = datosCinco.length > 0 ? datosCinco[0].datos : '';

  // Categoría
  var datosSeis = datosPersonales.filter(fila => fila.width === "seis");
  var categoria = datosSeis.length > 0 ? datosSeis[0].datos : '';

  // Régimen
  var datosSiete = datosPersonales.filter(fila => fila.width === "siete");
  var regimen = datosSiete.length > 0 ? datosSiete[0].datos : '';

  // Resolución y Semestre (solo DOC)
  var resolucion = datosUno.length > 0 ? (datosUno[0].resolucion || '') : '';
  var semestre = datosUno.length > 0 ? (datosUno[0].semestres || '') : '';

  // ============ FUENTE TIMES NEW ROMAN ============
  doc.setFont('times');

  // ============ ENCABEZADO ============
  doc.setFontSize(16);
  doc.text('UNIVERSIDAD NACIONAL DE SAN ANTONIO ABAD DEL CUSCO', 20, 30);
  doc.setFontSize(12);
  doc.text('UNIDAD DE RECURSOS HUMANOS - SUBUNIDAD DE REMUNERACIONES', 30, 40);

  // Linea separadora
  doc.line(20, 45, 190, 45);

  // ============ TITULO CENTRADO ============
  doc.setFontType('bold');
  doc.setFontSize(16);
  var titulo = 'DECLARACION JURADA';
  var pageWidth = doc.internal.pageSize.getWidth();
  doc.text(titulo, pageWidth / 2, 60, {align: 'center'});

  // Nombre de la declaracion centrado
  doc.setFontSize(14);
  doc.text(tituloDeclaracion, pageWidth / 2, 67, {align: 'center'});
  doc.setFontType('normal');

  // ============ TEXTO DEL CUERPO ============
  doc.setFontSize(16);

  var textCuerpo = '';
  if (tipoPlanilla === 'DOA') {
    textCuerpo = 'Yo ' + nombres + ' ' + apellidopaterno + ' ' + apellidomaterno +
      ', identificado(a) con DNI No.: ' + dni +
      ', en la condicion de DOCENTE NOMBRADO con Categoria ' + categoria +
      ' y Regimen: ' + regimen +
      ' del Departamento de ' + departamento +
      ' de la Escuela ' + escuela + '.';
  } else if (tipoPlanilla === 'DOC') {
    textCuerpo = 'Yo ' + nombres + ' ' + apellidopaterno + ' ' + apellidomaterno +
      ', identificado(a) con DNI No.: ' + dni +
      ', en la condicion de DOCENTE CONTRATADO con Categoria ' + categoria +
      ' y Regimen: ' + regimen +
      ' del Departamento de ' + departamento +
      ' de la Escuela ' + escuela +
      ' con contrato a traves de la Resolucion ' + resolucion +
      ' para el semestre ' + semestre + '.';
  }

  // Renderizar como bloque unico (jsPDF 1.4.1 ignora lineHeightFactor en doc.text, usa ~1.15 por defecto)
  doc.text(textCuerpo, 20, 90, {align: 'justify', maxWidth: 170});

  var scaleFactor = doc.internal.scaleFactor;
  // Usar el lineHeight real que aplica jsPDF 1.4.1 (factor 1.15 por defecto)
  var lineHCuerpo = (16 * 1.15) / scaleFactor;
  var lineHDecl   = (14 * 1.5) / scaleFactor;
  var gap = 5;
  var linesCuerpo = doc.splitTextToSize(textCuerpo, 170);
  // (N-1) llega al baseline de la ultima linea; mismo salto que entre parrafos de declaracion
  var yDecl = 90 + (linesCuerpo.length - 1) * lineHCuerpo + lineHDecl + gap;

  // Texto de declaracion (3 parrafos en negrita, posicion dinamica)
  doc.setFontType('bold');
  doc.setFontSize(14);

  var p1 = 'DECLARO BAJO JURAMENTO, la veracidad de lo siguiente:';
  var linesP1 = doc.splitTextToSize(p1, 170);
  doc.text(p1, 20, yDecl, { lineHeightFactor: 1.5, maxWidth: 170 });
  var yP2 = yDecl + (linesP1.length * lineHDecl) + gap;

  var p2 = 'No percibir el ' + tituloDeclaracion + ' de ninguna otra institución Pública bajo cualquier régimen laboral, siendo la UNSAAC la única en la que percibo.';
  var linesP2 = doc.splitTextToSize(p2, 170);
  doc.text(p2, 20, yP2, { align: 'justify', lineHeightFactor: 1.5, maxWidth: 170 });
  var yP3 = yP2 + (linesP2.length * lineHDecl) + gap;

  var p3 = 'En honor a la verdad, dejo constancia mediante mi firma digital, sometiéndome a las sanciones legales a que diera lugar su falsedad.';
  var linesP3 = doc.splitTextToSize(p3, 170);
  doc.text(p3, 20, yP3, { align: 'justify', lineHeightFactor: 1.5, maxWidth: 170 });

  doc.setFontType('normal');
  doc.setFontSize(16);

  // ============ LINEAS INFERIORES ============
  doc.line(20, 240, 190, 240);
  doc.line(20, 275, 190, 275);

  // ============ PIE DE PAGINA (textos estaticos) ============
  doc.setFontSize(9);
  doc.setFontType('bold');
  doc.text(pieTextos.titulo, 25, 245, {maxWidth: 165});
  doc.setFontType('normal');

  doc.setFontSize(8);
  doc.text(pieTextos.parrafo1, 25, 251, {align: 'justify', lineHeightFactor: 1.4, maxWidth: 165});
  doc.text(pieTextos.parrafo2, 25, 262, {align: 'justify', lineHeightFactor: 1.4, maxWidth: 165});

  if (formato === 'base64') {
    var dataUri = doc.output('datauristring');
    return dataUri.split(',')[1];
  }
  return doc.output('bloburl');
}

function obtenerPieTextos(clave, tituloDeclaracion) {
  var titulo = 'DISPOSICIONES REGLAMENTARIAS - ' + tituloDeclaracion;

  if (clave.indexOf('JULIO') >= 0 || clave.indexOf('PATRIAS') >= 0 || clave.indexOf('JUL') >= 0) {
    return {
      titulo: titulo,
      parrafo1: 'Los funcionarios, servidores y pensionistas de la Administracion Publica reciben el aguinaldo por Fiestas Patrias en una sola entidad publica, debiendo ser otorgada en aquella que abona el mayor monto de ingresos.',
      parrafo2: 'La percepcion del aguinaldo por Fiestas Patrias dispuesto por la Ley No. 32185, es incompatible con la percepcion de cualquier otro beneficio en especie o dinerario de naturaleza similar que, con igual o diferente denominacion, otorga la entidad publica, independientemente de la fecha de su percepcion en el presente Anio Fiscal.'
    };
  }

  if (clave.indexOf('DICIEMBRE') >= 0 || clave.indexOf('NAVIDAD') >= 0 || clave.indexOf('NAV') >= 0 || clave.indexOf('DIC') >= 0) {
    return {
      titulo: titulo,
      parrafo1: 'Los funcionarios, servidores y pensionistas de la Administracion Publica reciben el aguinaldo por Navidad en una sola entidad publica, debiendo ser otorgada en aquella que abona el mayor monto de ingresos.',
      parrafo2: 'La percepcion del aguinaldo por Navidad dispuesto por la Ley No. 32185 es incompatible con la percepcion de cualquier otro beneficio en especie o dinerario de naturaleza similar que, con igual o diferente denominacion, otorga la entidad publica, independientemente de la fecha de su percepcion en el presente Anio Fiscal.'
    };
  }

  if (clave.indexOf('ESCOLARIDAD') >= 0 || clave.indexOf('ESCOL') >= 0) {
    return {
      titulo: titulo,
      parrafo1: 'El personal activo y pensionista de la Administracion Publica percibe la Bonificacion por Escolaridad en una sola entidad publica, debiendo ser otorgada en aquella que abona el mayor monto de ingresos.',
      parrafo2: 'La percepcion de la Bonificacion por Escolaridad dispuesta por la Ley No. 32513 es incompatible con la percepcion de cualquier otro beneficio en especie o dinerario de naturaleza similar que, con igual o diferente denominacion, otorga la entidad publica, independientemente de la fecha de su percepcion dentro del presente anio fiscal.'
    };
  }

  return { titulo: titulo, parrafo1: '', parrafo2: '' };
}
